import React from "react";
import styles from "./CheckboxGroup.module.scss";
import Label from "../../base/Label/Label";

interface CheckboxOption {
  value: string;
  label: string;
  icon?: React.ReactNode;
  buttonName: string;
}

interface CheckboxGroupProps {
  label: string;
  name: string;
  options: CheckboxOption[];
  value: string[];
  onChange: (values: string[]) => void;
  className?: string;
}

export default function CheckboxGroup({
  label,
  name,
  options,
  value,
  onChange,
  className,
}: CheckboxGroupProps) {
  const toggle = (val: string) => {
    if (value.includes(val)) {
      onChange(value.filter((v) => v !== val));
    } else {
      onChange([...value, val]);
    }
  };

  return (
    <div className={`${styles.checkboxGroupContainer} ${className}`}>
      {label && (
        <Label htmlFor={name} style={{ fontWeight: "600" }}>
          {label}
        </Label>
      )}

      <div className={styles.options}>
        {options.map((option) => {
          const selected = value.includes(option.value);

          return (
            <button
              type="button"
              key={option.value}
              className={`${styles.option} ${selected ? styles.selected : ""}`}
              aria-label={option.buttonName}
              onClick={() => toggle(option.value)}
            >
              {option.icon && <div className={styles.icon}>{option.icon}</div>}

              {option.label.length ? <span className={styles.label}>{option.label}</span> : <></>}
            </button>
          );
        })}
      </div>
    </div>
  );
}
